import { render, staticRenderFns } from "./Recording.vue?vue&type=template&id=0e167c95&scoped=true"
import script from "./Recording.vue?vue&type=script&lang=js"
export * from "./Recording.vue?vue&type=script&lang=js"
import style0 from "./Recording.vue?vue&type=style&index=0&id=0e167c95&prod&lang=css"
import style1 from "./Recording.vue?vue&type=style&index=1&id=0e167c95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e167c95",
  null
  
)

export default component.exports